import React from "react";
import { Spinner } from "react-bootstrap";
import { FiEye } from "react-icons/fi";

const SettlementListTable = ({ loading, settlements, onViewDetails, getStatusBadge }) => {
  return (
    <div className="bma-card">
      <div className="bma-card-header">
        <h2 className="bma-card-title">Settlement List</h2>
      </div>
      <div className="p-0 table-responsive">
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <table className="bma-table">
            <thead>
              <tr>
                <th>Settlement Code</th>
                <th>Casting Director ID</th>
                <th>Type</th>
                <th>Period</th>
                <th>Transactions</th>
                <th>Initiated Amount (₹)</th>
                <th>Status</th>
                <th>Created Date</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {settlements.length > 0 ? (
                settlements.map((row) => {
                  const rowInitiatedAmount = Number(
                    row.net_payable_amount || 
                    row.paid_amount || 
                    row.net_amount || 
                    row.commission_amount || 
                    0
                  );

                  return (
                    <tr key={row.id}>
                      <td style={{ fontFamily: "monospace", fontWeight: "700", color: "#60a5fa" }}>
                        {row.batch_code}
                      </td>
                      <td>CD #{row.casting_director_id}</td>
                      <td>{row.settlement_type || "By Project"}</td>
                      <td style={{ color: "#94a3b8" }}>{row.settlement_period || "—"}</td>
                      <td style={{ fontWeight: "700" }}>{row.total_transactions_count || 0}</td>
                      <td style={{ fontWeight: "700", color: "#4ade80" }}>
                        ₹ {rowInitiatedAmount.toLocaleString("en-IN")}.00
                      </td>
                      <td>{getStatusBadge(row.status)}</td>
                      <td style={{ color: "#94a3b8" }}>
                        {row.created_at ? new Date(row.created_at).toLocaleDateString("en-IN") : "—"}
                      </td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="bma-btn-blue p-1"
                          style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                          onClick={() => onViewDetails(row)}
                          title="View Details"
                        >
                          <FiEye size={16} color="#ffffff" />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-5 text-muted">
                    No settlement records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        <div className="p-3 border-top d-flex justify-content-between align-items-center" style={{ fontSize: "0.85rem", color: "#94a3b8", borderColor: "#24283b" }}>
          <div>Showing {settlements.length} entries</div>
        </div>
      </div>
    </div>
  );
};

export default SettlementListTable;